<template>
  <div class="play-button">
    <a
      :href="href"
      target="_blank"
      class="btn --large --green"
      id="pad-get-game"
      pad-a="click"
      pad-start
      pad-up="go:#pad-notice,#pad-home"
      pad-right="go:#pad-news-1,#pad-banner"
      pad-left="run:leaveWebView,left"
    >
      <span class="btn__stroke"></span>
      <span class="btn__label">{{ $t("get_the_game") }} <iconGetGame /></span>
    </a>
  </div>
</template>

<script>
import iconGetGame from "@/components/Icons/iconGetGame";

export default {
  components: {
    iconGetGame
  },
  props: {
    href: {
      type: String,
      default: "",
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
}

.btn.--large {
  margin: 0;

  &::after {
    background-color: $green;
  }
}

svg {
  width: 21px;
  position: relative;
  top: -2px;
  margin-left: 10px;
}
</style>
